import { render } from "./Header.vue?vue&type=template&id=118c014d&scoped=true"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"

import "./Header.vue?vue&type=style&index=0&id=118c014d&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-118c014d"

export default script